// @deprecated refactor to prevent to many bool toggles
export const isUserLoading = (state) => state.entities.users.isFetching;
